<template>
  <div class="octobus__info">
    <p v-if="busInfo.bus" class="details__bus">{{$t('ticket.infoDefault')}}</p>
    <p v-if="busInfo.bus" class="octobus__content">{{busInfo.bus}}</p>

    <p v-if="busInfo.comfort" class="details__comfort">{{$t('ticket.infoComfort')}}</p>
    <p v-if="busInfo.comfort" class="octobus__content">{{busInfo.comfort}}</p>

    <div v-if="busInfo.discount" class="octobus__content">
      <p class="details__discount">{{$t('ticket.infoDiscount')}}</p>
      <ul>
        <li v-for="(item, key) in busInfo.discount" :key="key">{{item}}</li>
      </ul>
    </div>

    <div v-if="busInfo.luggage" class="octobus__content">
      <p class="details__bag">{{$t('ticket.infoLuggage')}}</p>
      <ul>
        <li v-for="(item, key) in busInfo.luggage" :key="key">{{item}}</li>
      </ul>
    </div>

    <div v-if="busInfo.refund" class="octobus__content">
      <p class="details__map">{{$t('ticket.infoRefund')}}</p>
      <ul>
        <li v-for="(item, key) in busInfo.refund" :key="key">{{item}}</li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Info',
  components: {
  },
  props: {
    busInfo: {
      type: Object,
      required: true,
    },
  },
  methods: {
  },
  computed: {
  },
};
</script>

<style lang='scss' scoped>
#app, #auth {
  .octobus__info {
    .details__discount,
    .details__bag,
    .details__map,
    .details__comfort,
    .details__bus {
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
      margin-bottom: 0.2rem;
  }
    .octobus__content {
      font-size: .9rem;
      line-height: 1.2;
      font-weight: 300;

      ul {
        list-style: none;
        margin-left: 0;
        margin-top: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Ticket/Info.vue